/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frontrow_AudienceInputs */

const en_frontrow_audience = /** @type {(inputs: Frontrow_AudienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For retailers and buyers`)
};

/**
* | output |
* | --- |
* | "For retailers and buyers" |
*
* @param {Frontrow_AudienceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const frontrow_audience = /** @type {((inputs?: Frontrow_AudienceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frontrow_AudienceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_frontrow_audience(inputs)
});